import PREFECTURES from "../constants/prefectures.json";

/**
 * Maps a numeric Japanese prefecture code to its name.
 * Returns the original value as-is for non-numeric or unrecognized codes.
 */
export function mapPrefecture(code) {
    if (!code) return "";
    const normalized = String(code).padStart(2, "0");
    return PREFECTURES[normalized] || code;
}
